(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  function initCustomSearchSuggestions() {
    const forms = document.querySelectorAll('.custom-search-form');
    if (!forms.length) return;

    const debounce = (fn, delay) => {
      let timer;
      return (...args) => {
        window.clearTimeout(timer);
        timer = window.setTimeout(() => fn.apply(this, args), delay);
      };
    };

    

    forms.forEach((form) => {
      const input = form.querySelector('.custom-search-input');
      const suggestionsBox = form.querySelector('.custom-search-suggestions');
      if (!input || !suggestionsBox) return;

      let activeIndex = -1;

      const clearSuggestions = () => {
        suggestionsBox.innerHTML = '';
        suggestionsBox.classList.remove('custom-search-suggestions--visible');
        activeIndex = -1;
      };

      const highlight = (index) => {
        const items = suggestionsBox.querySelectorAll('.custom-search-suggestion-item');
        if (!items.length) return;
        if (index < 0) index = items.length - 1;
        if (index >= items.length) index = 0;
        items.forEach((item, i) => {
          item.classList.toggle('custom-search-suggestion-item--active', i === index);
        });
        activeIndex = index;
      };

      const renderSuggestions = (results) => {
        suggestionsBox.innerHTML = '';
        if (!results || !results.length) {
          suggestionsBox.innerHTML = '<div class="custom-search-no-results">No matching products found.</div>';
          suggestionsBox.classList.add('custom-search-suggestions--visible');
          activeIndex = -1;
          return;
        }

        const fragment = document.createDocumentFragment();

        results.forEach((product, index) => {
          const link = document.createElement('a');
          link.href = product.url || '/search?q=' + encodeURIComponent(product.title);
          link.className = 'custom-search-suggestion-item';
          link.setAttribute('role', 'option');
          link.dataset.index = index;
          const imageHtml = product.image ? `<span class="custom-search-suggestion-thumb"><img src="${product.image}" alt="${product.title}" loading="lazy"></span>` : '';
          link.innerHTML = `${imageHtml}<span class="custom-search-suggestion-title">${product.title}</span>`;
          fragment.appendChild(link);
        });

        suggestionsBox.appendChild(fragment);
        suggestionsBox.classList.add('custom-search-suggestions--visible');
      };

      const fetchSuggestions = async (query) => {
        if (!query || query.length < 2) {
          clearSuggestions();
          return;
        }

        const url = new URL('/search/suggest.json', window.location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[options][unavailable_products]', 'last');
        url.searchParams.set('resources[limit]', '6');

        try {
          const response = await fetch(url);
          if (!response.ok) {
            clearSuggestions();
            return;
          }

          const data = await response.json();
          const products = data.resources?.results?.products || [];

          const mapped = products.map((product) => ({
            title: product.title,
            url: product.url || (product.handle ? `/products/${product.handle}` : `/search?q=${encodeURIComponent(product.title)}`),
            image: product.image ? (product.image.src || product.image) : null
          }));

          renderSuggestions(mapped);
        } catch (error) {
          clearSuggestions();
        }
      };

      const debouncedFetch = debounce((event) => fetchSuggestions(event.target.value.trim()), 180);

      input.addEventListener('input', debouncedFetch);
      input.addEventListener('keydown', (event) => {
        const items = suggestionsBox.querySelectorAll('.custom-search-suggestion-item');
        if (!items.length) return;

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          highlight(activeIndex + 1);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          highlight(activeIndex - 1);
        } else if (event.key === 'Enter' && activeIndex > -1) {
          event.preventDefault();
          window.location.href = items[activeIndex].href;
        } else if (event.key === 'Escape') {
          clearSuggestions();
        }
      });

      suggestionsBox.addEventListener('mousedown', (event) => {
        event.preventDefault();
      });

      suggestionsBox.addEventListener('click', (event) => {
        const item = event.target.closest('.custom-search-suggestion-item');
        if (!item) return;
        event.preventDefault();
        window.location.href = item.href;
      });

      input.addEventListener('blur', () => {
        window.setTimeout(clearSuggestions, 150);
      });
    });
  }
   
  
  document.addEventListener('DOMContentLoaded', initCustomSearchSuggestions);

  } catch(e) { console.error(e); }
})();
})();
